
<span class="d-block">{{ step5.getspan19 | translate}}</span>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="(initial?.procedure?.txtLibre?.champsLibre && initial.procedure.txtLibre.champsLibre.length > 0) ? initial.procedure.txtLibre.champsLibre[0] : null"
[label]="step5.gettextelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidTxtLibre()+'_SepAtt_champsLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.procedure.intLibre?.intituleLibre"
[label]="step5.getintitulelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidIntLibre()+'_SepAtt_intituleLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.procedure.intLibre?.intituleLibreLibelle"
[label]="step5.getintitulelibrelibelle"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidIntLibre()+'_SepAtt_intituleLibreLibelle'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.procedure.dateLibre?.intitule"
[label]="step5.getintitule"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidDateLibre()+'_SepAtt_intitule'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.procedure.dateLibre?.dateHeureLibre"
[label]="step5.getdateheurelibre"
[rule]="''"
[type]="'datetime'"
[name]="getUidDateLibre()+'_SepAtt_dateHeureLibre'">
</app-form-input>

<app-type-delais-divers [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [delais]="initial?.delais"></app-type-delais-divers>

